module.exports = __webpack_public_path__ + "img/331A0B_B17038_7D4E28_5B351A-256px.b5f8c529.png";